import DataTableController from "../data_table_controller";
import BulkPhoneActions from "./bulk_phone_actions";

export default class FreePhonesTableController extends DataTableController {
  constructor(...args) {
    super(...args);

    this.bulkActions = new BulkPhoneActions();
    this.bulkActions.init();

    this.filterResetHooked = false;
  }

  destroy() {
    this.bulkActions?.destroy();
    this.bulkActions = null;

    super.destroy?.();
  }

  headerCallback(thead, data) {
    this.bulkActions?.resetSelection();
  }
}
